import { MouseEvent } from 'react';
import { Flex, ThemeUIStyleObject } from 'theme-ui';
import filterDuplicates from '~/utils/filter-duplicates';
type Props = {
  callback?: (variant: Queries.VariantDetailsFragmentFragment, query: string, event: MouseEvent) => void;
  product: Queries.ProductCardFragmentFragment | undefined;
  forwardSx?: ThemeUIStyleObject;
};
const ColorSwatch = ({ callback, product, forwardSx }: Props) => {
  if (!product?.variants?.length) return null;
  const availableOptionValues: (Queries.OptionValuesFragmentFragment | null)[] = filterDuplicates(
    product.variants.reduce<(Queries.OptionValuesFragmentFragment | null)[]>(
      (acc, item) => (item?.optionValues ? [...acc, ...item?.optionValues] : acc),
      []
    ),
    'slug'
  );
  const allColors = availableOptionValues?.filter(
    (optionValue) => optionValue?.option_type?.length && optionValue?.option_type[0]?.slug === 'color'
  );

  const makeSelection = (ov: Queries.OptionValuesFragmentFragment, event: MouseEvent) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const query = `color=${ov.presentation}`;
    const variant = product?.variants?.find((v) => v?.optionValues?.find((o) => o?.slug === ov.slug));
    if (callback && variant) callback(variant, query, event);
  };

  const colors = allColors.map((ov) => {
    if (!ov) return null;
    return (
      <div
        data-testid={ov.presentation}
        onClick={(event) => makeSelection(ov, event)}
        onMouseEnter={(event) => makeSelection(ov, event)}
        key={ov.alternateRendering}
        sx={{
          cursor: 'pointer',
          position: 'relative',
          overflow: 'hidden',
          aspectRatio: '1',
          minHeight: 'var(--dots)',
          minWidth: 'var(--dots)',
          backgroundColor: ov.alternateRendering || 'black',
          border: '1px solid transparent',
          borderColor: ov.alternateRendering === '#E1E1E1' && 'darkCloud',
          borderRadius: '50%',
          '::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundColor: ov.alternateRendering2 ? ov.alternateRendering2 : null,
            clipPath: 'polygon(100% 0, 0% 100%, 100% 100%)',
          },
        }}
      />
    );
  });
  return (
    <Flex sx={{ gap: '6px', flexWrap: 'wrap', ...forwardSx }} data-testid="color-swatch">
      {colors}
    </Flex>
  );
};

export default ColorSwatch;
